module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-334.8067251.woff2";